export enum TextFilterOption {
  contain = 'contains',
  notContain = 'notContains',
  equal = 'equals',
  notEqual = 'notEqual',
  startsWith = 'startsWith',
  endsWith = 'endsWith'
}
